<div class="card kpi-red">
    <div class="card-body kpi-card">
        <h5 class="card-title">
            Prix moyen au m²
            <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
               matTooltip="Prix moyen pour {{ cityService.getFullLib(favorite.advice_price_real, favorite.ad_city, favorite.iris) }}">
            </i>
        </h5>
        <p class="card-value">
            <ng-container *ngIf="preview">- €/m²</ng-container>
            <ng-container *ngIf="!preview">
                {{ favorite.advice_price | number:'1.0-0'  }} <span class="unit">€/m²</span>
            </ng-container>
        </p>
    </div>
</div>
